import { R } from '@core/utils/r';

export function isEmail(value: string) {
  return R.isString(value) && !!value.match(/.+\@.+\..+/);
}
